import React, { useEffect } from 'react';
import { BackTop, Button, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';

const initial = {
    hrTransferPersonalDataId: null,
    hrDisclosureTitleTh: 'การเปิดเผยข้อมูลส่วนบุคคลของคู่ค้า',
    hrDisclosureTitleEn: 'Disclosure personal data of Partners',
    hrDisclosureContentTh: '',
    hrDisclosureContentEn: '',
    hrDisclosureIsDisplay: true,
    hrInternationalTitleTh: 'การส่งหรือโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ',
    hrInternationalTitleEn: 'International transfers of Personal Data',
    hrInternationalContentTh: '',
    hrInternationalContentEn: '',
    hrInternationalIsDisplay: true,
};

export default function Step5(props) {
    const { setStep5, editData } = props;
    const { form } = props;
    const { t } = useTranslation(['hr-policy']);

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                setStep5(true);
            })
            .catch(() => setStep5(false));
        props.nextStep();
    };
    const onPreviousStep = () => {
        props.previousStep();
    };
    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'hrDisclosureTitleTh',
                'hrDisclosureTitleEn',
                'hrDisclosureContentTh',
                'hrInternationalTitleTh',
                'hrInternationalTitleEn',
                'hrInternationalContentTh',
            ];
            for (const [key, value] of Object.entries(
                editData?.hrTransferPersonalData
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep5(check);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData]);
    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-xl">
                {t('Who we will disclose or transfer personal data')}
            </div>
            <div className="text-gray-500 text-tiny">
                {t('policy.desEtc', { ns: 'translation' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onValuesChange={(e, allFields) => {
                    let check = true;
                    const allowKey = [
                        'hrDisclosureTitleTh',
                        'hrDisclosureTitleEn',
                        'hrDisclosureContentTh',
                        'hrInternationalTitleTh',
                        'hrInternationalTitleEn',
                        'hrInternationalContentTh',
                    ];
                    for (const [key, value] of Object.entries(allFields)) {
                        if (allowKey.includes(key) && !value) {
                            check = false;
                        }
                    }
                    setStep5(check);
                }}
                initialValues={initial}
            >
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('Disclosure personal data of Partners')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrDisclosureTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input size="large" showCount maxLength={200} />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`บริษัทจะเก็บรักษาข้อมูลส่วนบุคคลของท่านตราบเท่าที่จำเป็นตามสมควรเพื่อบรรลุวัตถุประสงค์ที่บริษัทได้รับมาและเพื่อปฏิบัติตามข้อผูกพันทางกฎหมายและข้อบังคับของบริษัท\nข้อมูลส่วนบุคคลของท่านจะถูกเก็บไว้ในช่วงเวลาของการจ้างงานหรือความสัมพันธ์ในการให้บริการของท่านรวมถึงหลังจากนั้นตราบใดที่ยังมีภาระผูกพันตามกฎหมายหรือการเรียกร้องที่อาจเกิดขึ้นจากความสัมพันธ์ในการจ้างงาน`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrDisclosureContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodThPl', {
                            ns: 'translation',
                        })}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrDisclosureTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input size="large" showCount maxLength={200} />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`The company will only retain your personal data as necessary and appropriate to achieve the purposes for which the company has received them and to comply with legal obligations and company regulations. Your personal data will be kept during the period of your employment or business relationship with the company, including thereafter as long as there are legal obligations or claims arising from the employment relationship.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrDisclosureContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor size="large" rows={4} />
                </Form.Item>
                <Divider />
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('International transfers of Personal Data')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrInternationalTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input size="large" showCount maxLength={200} />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`บริษัท ตระหนักถึงความสำคัญของการรักษาความปลอดภัยของข้อมูลส่วนบุคคลของท่าน บริษัทจึงพยายามที่จะปกป้องข้อมูลของท่านโดยการกำหนดมาตรการรักษาความปลอดภัยสำหรับข้อมูลส่วนบุคคลของท่านอย่างเหมาะสมและสอดคล้องกับการรักษาความลับของข้อมูลส่วนบุคคลเพื่อป้องกันการสูญหาย การเข้าถึงโดยคนที่ไม่ได้รับอนุญาตหรือโดยผิดกฎหมาย การทำลาย การใช้ การแก้ไขดัดแปลง หรือเปิดเผย โดยไม่ได้รับอนุญาต อย่างไรก็ตามบริษัทจะรับรองว่าวิธีการรวบรวมจัดเก็บและประมวลผลข้อมูลส่วนบุคคลของท่าน รวมถึงมาตรการความปลอดภัยทางกายภาพเป็นไปตามนโยบายความปลอดภัยของเทคโนโลยีสารสนเทศและแนวทางของบริษัท`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrInternationalContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodThPl', {
                            ns: 'translation',
                        })}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrInternationalTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input size="large" showCount maxLength={200} />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`The Company recognizes the importance of maintaining the security of your Personal Data. Therefore, the Company endeavors to protect your information by establishing security measures for your Personal Data appropriately and in accordance with the confidentiality safeguard of personal information, to prevent loss, unauthorized or unlawful access, destruction, use, alteration, or disclosure; provided, however, that the Company will ensure that the method of collecting, storing and processing of your Personal Data, including physical safety measures follow the information technology security policies and guidelines of the Company.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrInternationalContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor size="large" rows={4} />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    {props.editMode ? (
                        <BtnSave
                            goToStep={props.goToStep}
                            loading={props.loading}
                        />
                    ) : (
                        <div className="flex gap-2 items-center">
                            <Button
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                            >
                                <ArrowLeftOutlined />{' '}
                                {t('policy.PreviousStep', {
                                    ns: 'translation',
                                })}
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                onClick={onNextStep}
                            >
                                {t('policy.NextStep', { ns: 'translation' })}{' '}
                                <ArrowRightOutlined />
                            </Button>
                            <div
                                style={{ borderLeft: '1px solid #DBDBDB' }}
                                className="ml-6"
                            >
                                <Button
                                    onClick={props.saveDraft}
                                    className="text-[#1890FF]"
                                    type="link"
                                >
                                    {t('Save Draft')}
                                </Button>
                                <span>{t('to save the latest changes')}</span>
                            </div>
                        </div>
                    )}
                </Sticky>
            </Form>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
